// Holds the OmniChic popup back while Shopify's cookie banner or its preferences panel shows.
// OmniChic re-checks only when a body class changes, and the banner hides by inline style, so this class is the signal.
(function () {
  var IDS = ["shopify-pc__banner", "shopify-pc__prefs"];
  var watched = {};
  function shown(el) { return !!el && getComputedStyle(el).display !== "none"; }
  function sync() {
    var open = IDS.some(function (id) { return shown(document.getElementById(id)); });
    document.body.classList.toggle("vc-consent-open", open);
  }
  function attach() {
    IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && watched[id] !== el) {
        watched[id] = el;
        new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ["style", "class"] });
      }
    });
    sync();
  }
  function start() {
    attach();
    new MutationObserver(attach).observe(document.body, { childList: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
